import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate, useParams } from "react-router-dom";

import api from "@/services/api";
import toast from "react-hot-toast";
import Loader from "@/components/Loader";
import SingleSelect from "../components/SingleSelect";
import CurrencyInput from "react-currency-input-field";

const MarketCharacteristics = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { id } = useParams();
  const [values, setValues] = useState();
  const [questions, setQuestions] = useState();

  useEffect(() => {
    fetchQuestions();
    fetchData();
  }, [id]);

  const fetchQuestions = async () => {
    try {
      const res = await api.post("/question/search", { limit: 300, startup: true });
      if (res.ok) {
        setQuestions(res.data);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const fetchData = async () => {
    try {
      const res = await api.get(`/company/${id}`);
      if (res.ok) {
        if (!res.data.plan) res.data.plan = "certified";
        setValues(res.data);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleChange = async () => {
    try {
      const res = await api.put(`/company/${id}`, values);
      if (!res.ok) throw new Error("Une erreur s'est produite lors de la mise à jour de la valeur");
      toast.success("Valeur mise à jour avec succès");
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleNext = async () => {
    await handleChange();
    navigate(`../form-market-competitors`);
  };

  if (!values) return <Loader />;

  return (
    <div className="w-full space-y-8 px-40">
      <SingleSelect question={questions?.find((q) => q.key === "entry_investment_requirements")} values={values} setValues={setValues} />

      <div>
        <label className="block text-gray-700 text-sm font-bold mb-2">
          {t("lable.the_amount_already_made_to_enter_the_market")}
          <span className="ml-2 text-red-500">*</span>
        </label>
        <div className="flex gap-2 input justify-between items-center">
          <CurrencyInput
            intlConfig={{ locale: "fr-FR", currency: "EUR" }}
            decimalsLimit={2}
            className=" w-[90%] focus:outline-none tracking-wider"
            placeholder={t("placeholder_enter")}
            value={values?.entry_investment_amount}
            onValueChange={(_, name, value) => setValues((prev) => ({ ...prev, entry_investment_amount: value.float }))}
          />
        </div>
      </div>

      <SingleSelect question={questions?.find((q) => q.key === "market_maturity")} values={values} setValues={setValues} />

      <div>
        <label className="block text-gray-700 text-sm font-bold mb-2">
          {t("lable.does_ur_product_require_authorisations_to_enter_the_market")} <span className="ml-2 text-red-500">*</span>
        </label>
        <div className="flex gap-10 mt-3">
          <div className="flex gap-4 items-center justify-center">
            <input
              type="radio"
              id="product_yes"
              name="has_product_authorization_needs"
              onChange={() => setValues((prev) => ({ ...prev, has_product_authorization_needs: true }))}
              checked={values?.has_product_authorization_needs === true}
            />
            <label className="block text-gray-700 text-sm font-bold" htmlFor="product_yes">
              {t("yes")}
            </label>
          </div>
          <div className="flex gap-4 items-center justify-center">
            <input
              type="radio"
              id="product_no"
              name="has_product_authorization_needs"
              onChange={() => setValues((prev) => ({ ...prev, has_product_authorization_needs: false }))}
              checked={values?.has_product_authorization_needs === false}
            />
            <label className="block text-gray-700 text-sm font-bold" htmlFor="product_no">
              {t("no")}
            </label>
          </div>
        </div>
      </div>

      {values.has_product_authorization_needs && (
        <>
          <div>
            <label className="block text-gray-700 text-sm font-bold mb-2">
              {t("lable.indicate_ur_authorities")}
              <span className="ml-2 text-red-500">*</span>
            </label>
            <input
              className="input"
              placeholder={t("placeholder_enter")}
              value={values?.authorities || ""}
              onChange={(e) => setValues((prev) => ({ ...prev, authorities: e.target.value }))}
            />
          </div>
          <div>
            <label className="block text-gray-700 text-sm font-bold mb-2">
              {t("lable.have_you_obtained_auth")} <span className="ml-2 text-red-500">*</span>
            </label>
            <div className="flex gap-10 mt-3">
              <div className="flex gap-4 items-center justify-center">
                <input
                  type="radio"
                  id="auth_yes"
                  name="obtained_authorizations"
                  onChange={() => setValues((prev) => ({ ...prev, obtained_authorizations: true }))}
                  checked={values?.obtained_authorizations === true}
                />
                <label className="block text-gray-700 text-sm font-bold" htmlFor="auth_yes">
                  {t("yes")}
                </label>
              </div>
              <div className="flex gap-4 items-center justify-center">
                <input
                  type="radio"
                  id="auth_no"
                  name="obtained_authorizations"
                  onChange={() => setValues((prev) => ({ ...prev, obtained_authorizations: false }))}
                  checked={values?.obtained_authorizations === false}
                />
                <label className="block text-gray-700 text-sm font-bold" htmlFor="auth_no">
                  {t("no")}
                </label>
              </div>
            </div>
          </div>
          {!values.obtained_authorizations && (
            <>
              <SingleSelect question={questions?.find((q) => q.key === "refusal_rate")} values={values} setValues={setValues} />
              <SingleSelect question={questions?.find((q) => q.key === "authorization_timeline")} values={values} setValues={setValues} />{" "}
            </>
          )}
        </>
      )}

      <SingleSelect question={questions?.find((q) => q.key === "network_effects_presence")} values={values} setValues={setValues} />

      <SingleSelect question={questions?.find((q) => q.key === "special_features_demand_intensity")} values={values} setValues={setValues} />

      <SingleSelect question={questions?.find((q) => q.key === "market_fit")} values={values} setValues={setValues} />

      <div className="flex justify-between w-full">
        <Link to={`../form-market-position`} className="empty-button disabled:hover:bg-white px-10">
          {t("previous")}
        </Link>
        <div className="flex items-center gap-2">
          <button className="empty-button disabled:hover:bg-white px-10" onClick={handleChange}>
            {t("save")}
          </button>
          <button className="primary-button disabled:hover:bg-white px-10" onClick={handleNext}>
            {t("next")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default MarketCharacteristics;
